import { getCanvas } from './register';
var lastTime = 0;
var id = 0;

function hack(cb) {
  var now = Date.now();
  var nextTime = Math.max(lastTime + 23, now);
  id = setTimeout(function () {
    cb(lastTime = nextTime);
  }, nextTime - now);
  return id;
}

function requestAnimationFrame(cb) {
  var canvas = getCanvas();

  if (canvas.requestAnimationFrame) {
    return canvas.requestAnimationFrame(cb);
  } else {
    return hack(cb);
  }
}

function cancelAnimationFrame(id) {
  var canvas = getCanvas();

  if (canvas.cancelAnimationFrame) {
    return canvas.cancelAnimationFrame(id);
  } else {
    return clearTimeout(id);
  }
}

export { requestAnimationFrame, cancelAnimationFrame };
//# sourceMappingURL=requestAnimationFrame.js.map